import { VOICE_AUTH_TYPE } from "@/constants/voice";
import { Dialog } from "vant"
/**
 * 样式 views/index/index.less 弹窗样式
 * @param vm 传入当前vue实例
 */
export const overListenMessage = (vm: any) => {
  let isTT=window.platformSource==='tt'
  // 试听限制弹框提示
  let { isSuperVip, isIOS, isAPP } = vm;
  const currentSelectSpeaker = vm.getSpeakerRunOutInTrial()
  let config = {
    title: '免费试听已超过本月上限',
    message: `「${currentSelectSpeaker.name}」配音师属于付费声音，请拥有此声音后使用`,
    confirmButtonText: '购买会员',
    callback: '',
    type: 'alert'
  }
  if (isSuperVip) {
    // svip用户 校验付费发音人提示
    
    if (currentSelectSpeaker.vipAuth === VOICE_AUTH_TYPE.PAID) {
      config.message = (isIOS||isTT) && !isAPP 
        ? `「${currentSelectSpeaker.name}」配音师属于付费声音，请拥有此声音后使用`
        : `「${currentSelectSpeaker.name}」配音师属于付费声音，需要额外付费解锁使用`
      config.confirmButtonText = (isIOS||isTT) && !isAPP 
        ? '查看声音' : '购买声音'
      config.callback = 'buyVoice'
      config.type = 'confirm'
    }
  } else {
    //普通用户 校验付费发音人提示，校验会员发音人提示
    if (currentSelectSpeaker.vipAuth === VOICE_AUTH_TYPE.PAID) {
      config.message = (isIOS||isTT) && !isAPP 
        ? `「${currentSelectSpeaker.name}」配音师属于付费声音，请升级会员账号后再购买`
        : `「${currentSelectSpeaker.name}」配音师属于付费声音，需要先成为会员身份后才有购买资格`
    } else {
      config.message = (isIOS||isTT) && !isAPP 
      ? `「${currentSelectSpeaker.name}」配音师属于会员免费专属声音，请升级会员账号后使用`
      : `「${currentSelectSpeaker.name}」配音师属于会员免费专属声音，成为会员后可以免费使用`
    }
    config.confirmButtonText = (isIOS||isTT) && !isAPP 
      ? '知道了' : '购买会员'
    config.callback = (isIOS||isTT) && !isAPP 
      ? '' : 'goRechargeVip'
    config.type = (isIOS||isTT) && !isAPP 
      ? 'alert' : 'confirm'
  }
  let { type, title, message, confirmButtonText, callback} = config

  if (type === 'alert') {
    Dialog.alert({
      title,
      message,
      confirmButtonText,
      className: 'pop-confirm pop-alert',
      getContainer: '#page-audition',
    }).then(() => {
      // on close
    });
  } else {
    Dialog.confirm({
      title,
      message,
      confirmButtonText,
      className: 'pop-confirm',
      getContainer: '#page-audition',
      cancelButtonText: '取消'
    })
      .then((action) => {
        if(action === 'confirm') {
          callback && vm[callback].call(vm)
        }
      })
      .catch(() => {
        // on cancel
      });
  }
}

export const offlineSpeakerMessage = (offlineSpeakers) => {
  return Dialog.confirm({
    title: '配音师下线提示',
    message: `${offlineSpeakers.map(s => s.name).join('、')}已下线，点击确认按钮将文中已下线配音师全部替换为默认配音师`,
    confirmButtonText: '',
    className: 'pop-confirm',
    getContainer: '#page-audition',
    cancelButtonText: '取消'
  })
}